import { render, staticRenderFns } from "./BotBoosting.vue?vue&type=template&id=0a9d46be&scoped=true&"
import script from "./BotBoosting.vue?vue&type=script&lang=js&"
export * from "./BotBoosting.vue?vue&type=script&lang=js&"
import style0 from "./BotBoosting.vue?vue&type=style&index=0&id=0a9d46be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d46be",
  null
  
)

export default component.exports